import { render, staticRenderFns } from "./BaseSearchBar.vue?vue&type=template&id=79c450a4&scoped=true&"
import script from "./BaseSearchBar.vue?vue&type=script&lang=js&"
export * from "./BaseSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./BaseSearchBar.vue?vue&type=style&index=0&id=79c450a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c450a4",
  null
  
)

export default component.exports